import { useState, useRef, useEffect } from "react";

const LazyImage = ({
  src,
  alt,
  className = "",
  placeholder = null,
  onLoad = null,
  onError = null,
  onLoadingStateChange = null,
  maxWidth = null,
  maxHeight = null,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Проверяем, если изображение уже загружено (из кэша)
  useEffect(() => {
    if (isInView && !isLoaded && !hasError) {
      const img = new Image();
      img.onload = () => {
        handleLoad({ target: { complete: true } });
      };
      img.src = src;
    }
  }, [isInView, isLoaded, hasError, src]);

  const handleLoad = (e) => {
    setIsLoaded(true);
    if (onLoad) onLoad();
    if (onLoadingStateChange) onLoadingStateChange(true, false);
  };

  const handleError = () => {
    setHasError(true);
    if (onError) onError();
    if (onLoadingStateChange) onLoadingStateChange(false, true);
  };

  const imageSize = {
    ...(maxWidth && { maxWidth }),
    ...(maxHeight && { maxHeight }),
  };

  return (
    <div
      ref={imgRef}
      className={`lazy-image-container ${className}`}
      style={imageSize}
      {...props}
    >
      {!isInView && placeholder && (
        <div className="lazy-image-placeholder">{placeholder}</div>
      )}

      {isInView && !isLoaded && !hasError && (
        <div className="lazy-image-loading">
          <span>Загрузка изображения...</span>
        </div>
      )}

      {isInView && !hasError && (
        <img
          src={src}
          alt={alt}
          className={`lazy-image ${isLoaded ? "loaded" : "loading"}`}
          style={imageSize}
          onLoad={handleLoad}
          onError={handleError}
          loading="lazy"
        />
      )}

      {hasError && (
        <div className="lazy-image-error">
          <span>Не удалось загрузить изображение</span>
        </div>
      )}
    </div>
  );
};

export default LazyImage;
